// One icon set for every hosted page. Small icons are drawn on a 16px grid
// with a 1.5px stroke so they stay crisp at the size they render (12–18px);
// scaling a 24px icon down to 16px leaves a sub-pixel stroke. The medallion
// icons in the page HTML use the same shapes on a 24px grid.
//
// CommonJS so node:test can load it directly, like the other pure modules.

function svg (body, { viewBox = '0 0 16 16' } = {}) {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${viewBox}" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${body}</svg>`
}

const ICONS = {
  check: svg('<path d="m3.75 8.5 2.75 2.75 5.75-6.5"/>'),
  // Tinted disc: a feature the customer already has.
  checkCircle: svg('<circle cx="8" cy="8" r="8" fill="currentColor" fill-opacity="0.1" stroke="none"/><path d="m5 8.25 2 2 4-4.5"/>'),
  // Solid disc in the accent colour: a feature the purchase unlocks.
  checkCircleSolid: svg('<circle cx="8" cy="8" r="8" fill="currentColor" stroke="none"/><path d="m5 8.25 2 2 4-4.5" stroke="#fff"/>'),
  lock: svg('<rect x="3.25" y="7.25" width="9.5" height="6.5" rx="1.75"/><path d="M5.5 7.25V5.25a2.5 2.5 0 0 1 5 0v2"/>'),
  mail: svg('<rect x="1.75" y="3.25" width="12.5" height="9.5" rx="2"/><path d="m2.25 5.25 4.9 3.3a1.5 1.5 0 0 0 1.7 0l4.9-3.3"/>'),
  tag: svg('<path d="M7.6 2.25H3.5c-.7 0-1.25.55-1.25 1.25v4.1c0 .33.13.65.37.88l5.15 5.15c.49.49 1.28.49 1.77 0l4.09-4.09c.49-.49.49-1.28 0-1.77L8.48 2.62a1.25 1.25 0 0 0-.88-.37Z"/><circle cx="5.25" cy="5.25" r="0.6" fill="currentColor"/>')
}

module.exports = { ICONS }
